import Expired from "./expired";
import Group from "./group";
import Loading from "./loading";
import Login from "./login";
import Main from "./main";
import Question from "./question";
import Session from "./session";
import Stats from "./stats";
import Submit from "./submit";
import Result from "./result";
import NotFound from "./not-found";
import ThankYou from "./thank-you";
import WebSurvey from "./websurvey";

export default {
  Expired,
  Group,
  Loading,
  Login,
  Main,
  Question,
  Session,
  Stats,
  Submit,
  Result,
  NotFound,
  ThankYou,
  WebSurvey,
};
